export default "__VITE_ASSET__iHlLARb3__"